import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { cpf } from 'cpf-cnpj-validator';
import { MessageService } from 'primeng/api';
import { ConstantsFordProtect } from '../../models/constants/constants-ford-protect';
import { ContractSummary } from '../../models/contract-summary/contract-summary';
import { ContractReactivation } from '../../models/contract/contract-reactivation';
import { PaymentBoletoRequestDto } from '../../models/payment-method/payment-boleto-request';
import { PaymentBoletoResponseDto } from '../../models/payment-method/payment-boleto-response';
import { PaymentContractSummaryShort } from '../../models/payment-method/payment-contract-summary-short';
import { PaymentMethod } from '../../models/payment-method/payment-method';
import { PaymentMethodRequest } from '../../models/payment-method/payment-method-request';
import { CreateBoletoRequestDto } from '../../models/payment-method/sa-payments/request/create-boleto-request-dto';
import { CreateBoletoResponseDto } from '../../models/payment-method/sa-payments/response/create-boleto-response-dto';
import { GatewayListBoletoResponseDto } from '../../models/payment-method/sa-payments/response/gateway-list-boleto-response-dto';
import { ContractPaymentSignature } from '../../models/payment-signature/contract-payment-signature';
import { MessageExceptionService } from '../../services/message-exception/message-exception.service';
import { PaymentMethodService } from '../../services/payment-method/payment-method.service';

@Component({
    selector: 'app-payment-method',
    templateUrl: './payment-method.component.html',
    styleUrls: ['./payment-method.component.scss'],
    standalone: false
})
export class PaymentMethodComponent implements OnInit {
	private readonly destroyRef = inject(DestroyRef);

	typeCard = [
		{ label: 'Crédito', value: "CREDIT" },
		{ label: 'Débito', value: "DEBIT" }
	];

	monthCard = [
		{ label: '01', value: 1 },
		{ label: '02', value: 2 },
		{ label: '03', value: 3 },
		{ label: '04', value: 4 },
		{ label: '05', value: 5 },
		{ label: '06', value: 6 },
		{ label: '07', value: 7 },
		{ label: '08', value: 8 },
		{ label: '09', value: 9 },
		{ label: '10', value: 10 },
		{ label: '11', value: 11 },
		{ label: '12', value: 12 }
	];

	portionCard = [
		{ label: '1x', value: 1 },
		{ label: '2x', value: 2 },
		{ label: '3x', value: 3 },
		{ label: '4x', value: 4 },
		{ label: '5x', value: 5 },
		{ label: '6x', value: 6 },
		{ label: '7x', value: 7 },
		{ label: '8x', value: 8 },
		{ label: '9x', value: 9 },
		{ label: '10x', value: 10 },
		{ label: '11x', value: 11 },
		{ label: '12x', value: 12 }
	];

	yearCard: { label: number; value: number }[] = [];

	portion = 1;
	validateMonth!: { label: string; value: number };
	validateYear!: { label: number; value: number };

	portionTotal: number = 0;
	contract: number = 0;
	uuid: string = '';
	document: string = '';
	productCode: string = '';
	paymentContractSummaryShort: PaymentContractSummaryShort;
	paymentMethod: PaymentMethod;
	createBoletoRequestDto: CreateBoletoRequestDto;
	createBoletoResponseDto: CreateBoletoResponseDto;
	paymentBoletoRequestDto: PaymentBoletoRequestDto;
	contractPaymentSignature: ContractPaymentSignature;

	blockedUi = false;
	isSubmitted: boolean = false;
	isSubmittedDownload = false;
	isContractCreated = false;
	isToShowBackButton = false;

	isBarcode = false;
	isHasBoleto = false;
	barcode: string = '';
	dueDate: string = '';
	idBoleto: string = '';

	isValidationPayment = false;
	isValidationSignature = false;
	paymentMethodRequest: PaymentMethodRequest;
	isExpireContract = false;
	isCtaSuccess = false;
	private paymentDebounceTimer: ReturnType<typeof setTimeout> | null = null;

	contractReactivation: ContractReactivation;
	isBlockedExpireContract = false;

	contractSummary: ContractSummary = new ContractSummary();
	contractIdDownload = 0;

	maxDatePermitted = new Date();
	minDatePermitted = new Date();

	salesDate = new Date();
	labelGerarBoleto: string = '';

	constructor(private translateService: TranslateService,
		private messageService: MessageService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private paymentMethodService: PaymentMethodService,
		private messageExceptionService: MessageExceptionService) {

		this.paymentContractSummaryShort = this.paymentMethodService.getContractSummary();
		if (this.paymentContractSummaryShort === null) {
			this.paymentContractSummaryShort = new PaymentContractSummaryShort();
		}
		this.paymentMethod = new PaymentMethod();
		this.paymentMethodRequest = new PaymentMethodRequest();
		this.contractReactivation = new ContractReactivation();
		this.createBoletoRequestDto = new CreateBoletoRequestDto();
		this.createBoletoResponseDto = new CreateBoletoResponseDto();
		this.paymentBoletoRequestDto = new PaymentBoletoRequestDto();
		this.contractPaymentSignature = new ContractPaymentSignature();
	}

	ngOnInit() {

		this.activatedRoute.queryParams.pipe(
			takeUntilDestroyed(this.destroyRef)
		).subscribe(params => {

			this.uuid = params.uuid;

			this.contractSummarySearch(this.uuid);
			this.portionTotal = this.paymentContractSummaryShort.total / this.portion;
			this.yearCalculate();
			this.paymentMethod.uuid = this.uuid;
			this.validateMonth = this.monthCard[0];
			this.findBoletoByContractId(this.contract.toString());

			if (this.paymentContractSummaryShort.extension !== undefined ||
				this.paymentContractSummaryShort.productCode !== 'PREB') {
				this.isToShowBackButton = true;
			}
		});

		this.labelGerarBoleto = "Gerar Boleto";
	}

	contractSummarySearch(uuid: string) {
		this.paymentMethodService.getPaymentContractSummaryShort(uuid)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe({
				next: (response: PaymentContractSummaryShort) => {
					this.paymentContractSummaryShort = response;
					this.setDateBoleto(this.paymentContractSummaryShort.salesDate);
					this.portionCalculate();

					if (response.statusPayment === 5) { // 5 = PAGAMENTO REALIZADO
						this.paymentMethodRequest.success = true;
						this.paymentMethodRequest.message = 'Pagamento realizado com sucesso.';
						this.paymentMethodRequest.statusCard = 'Pagamento realizado com sucesso.';
						this.isValidationPayment = true;
						(document.getElementById("btnStatusPayment") as HTMLInputElement).style.display = 'none';


						if (response.statusContract === ConstantsFordProtect.CONTRACT_ATIVO_CODE) { // 5 = CONTRATO ATIVO
							this.paymentMethodRequest.message += " O seu contrato já está ativo.";
							this.paymentMethodRequest.statusCard += " O seu contrato já está ativo.";
							this.isValidationSignature = true;
							(document.getElementById("btnStatusPayment") as HTMLInputElement).style.display = 'none';

						}
					} else {
						if (this.expireContract(response.createContractDate) > response.daysExpireContract) {
							this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Contrato expirado entrar em contato com vendedor.' });
							this.isExpireContract = true;
							this.contractReactivation.uuid = this.paymentMethod.uuid;
						}
					}
				},
				error: (err) => {

					if (err.status === 404) {
						this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Contrato não encontrado.' });
					} else {
						this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Busca de contrato inválida, aguarde e tente novamente.' });
					}
				}
			});
	}

	private expireContract(createContractDate: Date): number {
		const data = new Date();
		const datafim = new Date(createContractDate);
		const diffInMs = Math.abs(data.getTime() - datafim.getTime());
		const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
		return diffInDays;
	}

	yearCalculate() {
		const date = new Date();
		const dateLabelYear = date.getFullYear();

		for (let i = 0; i < 15; i++) {
			const year = dateLabelYear + i;
			this.yearCard.push({ label: year, value: year });
		}

		this.validateYear = this.yearCard[0];
	}

	portionCalculate() {
		this.portionTotal = this.paymentContractSummaryShort.total / this.portion;
	}

	contractPayment() {
		if (this.validation()) {
			this.isSubmitted = true;
			this.blockedUi = true;

			this.paymentMethod.cardTypeEnum = 'CREDIT';
			this.paymentMethod.cardValidateMonth = this.validateMonth.value;
			this.paymentMethod.cardValidateYear = this.validateYear.value;
			this.paymentMethod.cardNumberOfInstallment = this.portion;
			this.paymentMethod.uuid = this.uuid;

			this.paymentMethodService.postPaymentMethod(this.paymentMethod)
				.pipe(takeUntilDestroyed(this.destroyRef))
				.subscribe({
					next: (response: PaymentMethodRequest) => {
						if (response.success) {
							this.paymentMethodRequest = response;
							this.paymentMethodRequest.message = 'Pagamento realizado com sucesso.';
							this.isValidationPayment = response.success;
							this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Pagamento realizado com sucesso.' });
							this.contractIdDownload = this.contract;
							if (this.paymentContractSummaryShort.extension !== undefined) {
								this.save();
							}
						} else {
							this.messageService.add({ severity: 'error', summary: 'Erro', detail: response.message });
						}
						this.isSubmitted = false;
						this.blockedUi = false;
						if (this.paymentContractSummaryShort.extension !== undefined) {
							this.save();
						}
					},
					error: (err) => {

						this.isSubmitted = false;
						this.blockedUi = false;

						if (err.status === 404) {
							this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Contrato não encontrado.' });
						} else {
							this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Pagamento inválido, aguarde e tente novamente.' });
						}
					}
				});
		}
	}

	validation(): boolean {
		let isValid = true;
		if (this.paymentMethod.cardNumber === undefined || this.paymentMethod.cardNumber.length <= 0) {
			this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Número do cartão deve ser preenchido.' });
			isValid = false;
		}

		if (this.paymentMethod.cardSecurityCode === undefined) {
			this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'CVV deve ser preenchido.' });
			isValid = false;
		}

		if (this.paymentMethod.cardName === undefined) {
			this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Nome impresso no cartão deve ser preenchido.' });
			isValid = false;
		}

		if (this.paymentMethod.cardName !== undefined && this.paymentMethod.cardName.replace(/([^\d])+/gim, '').length > 0) {
			this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Nome impresso no cartão não pode ter numero.' });
			isValid = false;
		}

		if (this.paymentMethod.cardDocument === undefined) {
			this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'CPF deve ser preenchido.' });
			isValid = false;
		}

		if (this.paymentMethod.cardDocument !== undefined && cpf.isValid(this.paymentMethod.cardDocument) === false) {
			this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'CPF inválido.' });
			isValid = false;
		}

		return isValid;
	}

	reactivateContract() {
		this.isSubmitted = true;
		this.blockedUi = true;

		this.paymentMethodService.postPaymentMethodContractReactivation(this.contractReactivation)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe({
				next: (response: boolean) => {

					if (response) {
						this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Solicitação realizada com sucesso.' });
					} else {
						this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Solicitação inválida, aguarde e tente novamente.' });
					}

					this.isBlockedExpireContract = response;
					this.isSubmitted = false;
					this.blockedUi = false;
				},
				error: (err) => {

					this.isSubmitted = false;
					this.blockedUi = false;

					if (err.status === 404) {

						this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Contrato não encontrado.' });
					} else {
						this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Solicitação inválida, aguarde e tente novamente.' });
					}
				}
			});
	}
	get isPaymentFormComplete(): boolean {
		if (this.isValidationPayment) return true;

		return this.validation();
	}

	onPaymentFieldChange() {
		if (this.paymentDebounceTimer) {
			clearTimeout(this.paymentDebounceTimer);
		}
		this.isCtaSuccess = false;

		this.paymentDebounceTimer = setTimeout(() => {
			this.isCtaSuccess = this.isPaymentFormComplete;
		}, 700);
	}
	isEmail(search: string): boolean {

		const regexp = new RegExp(/^(([^<>()[]\\.,;:\s@"]+(\.[^<>()[]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z-0-9]+\.)+[a-zA-Z]{2,}))$/);
		return regexp.test(search);
	}

	save(): void {

		this.isSubmitted = true;
		this.blockedUi = true;

		this.contractPaymentSignature = this.paymentMethodService.getContractPaymentSignature();
		this.paymentMethodService.save(this.contractPaymentSignature)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe({
				next: (response: ContractPaymentSignature) => {
					this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Contrato criado com sucesso.' })
					this.contractIdDownload = response.contractId;
					this.isContractCreated = true;
					this.blockedUi = false;
				},
				error: (err) => {

					this.isSubmitted = false;
					this.blockedUi = false;
					this.isContractCreated = false;
					this.messageExceptionService.getMessageException(err.status, 'Não foi possível salvar o contrato, por gentileza, fecha a página e faça o login novamente!');
				}
			});
	}

	/**
	 * @param contractId 
	 * 1 - Se nenhum boleto tiver sido gerado, o label do botão deverá ser "Gerar Boleto";
	 * 2 - Se algum boleto tiver sido gerado anteriormente, então o label deverá ser "Gerar Novo Boleto";
	 * 3 - O boleto é considerado PAGO quando o status é do tipo COMPLETED;
	 * 4 - Se o boleto for do tipo PENDING e a data de vencimento for menor do que a data atual,
	 * então é aberta a possibilidade para a geração de um novo boleto;
	 */
	findBoletoByContractId(contractId: string) {
		this.paymentMethodService.findBoletoSaPaymentsByContractId(contractId)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe({
				next: (gateway: GatewayListBoletoResponseDto) => {
					gateway.response.forEach(boleto => {
						
						if (boleto.status !== "" && boleto.status !== "COMPLETED") {
							this.isHasBoleto = true;
							this.barcode = boleto.code;
							this.dueDate = boleto.dueDate;
							this.idBoleto = boleto.id;
						} else {
							this.isHasBoleto = false;
							this.barcode = "";
							this.dueDate = "";
							this.idBoleto = "";
						}
					});
				}
			});
	}

	saveBoletoContract() {
		this.isSubmitted = true;
		this.blockedUi = true;
		this.isBarcode = false;
		this.isHasBoleto = false;

		this.setPaymentBoletoRequestDto();

		this.paymentMethodService.postPaymentBoleto(this.paymentBoletoRequestDto)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe({
				next: (response: PaymentBoletoResponseDto) => {
					if (response.httpCode === 200) {
						this.createBoletoResponseDto = response.boletoResponseDto;
						this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: response.message });
						this.isBarcode = true;
						this.isHasBoleto = true;
						this.barcode = this.createBoletoResponseDto.code;
						this.dueDate = this.createBoletoResponseDto.dueDate;
						this.idBoleto = this.createBoletoResponseDto.id;

					} else {
						this.messageService.add({ severity: 'error', summary: 'Erro', detail: response.message });
					}
					this.isSubmitted = false;
					this.blockedUi = false;
				},
				error: (err) => {

					this.isSubmitted = false;
					this.blockedUi = false;
					if (err.status === 404) {
						this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Contrato não encontrado.' });
					} else {
						this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Não foi possível criar o boleto.' });
					}
				}
			});
	}

	setPaymentBoletoRequestDto() {
		this.paymentBoletoRequestDto.documentId = this.document;
		this.paymentBoletoRequestDto.contractId = this.contract;
		this.paymentBoletoRequestDto.dueDate = this.createBoletoRequestDto.dueDate;
		this.paymentBoletoRequestDto.uuid = this.uuid;
	}

	downloadBoletoSaPayments() {
		this.isSubmittedDownload = true;
		this.blockedUi = true;

		// delay de 1 segundo
		setTimeout(() => {

			this.paymentMethodService.downloadBoleto(this.idBoleto)
				.pipe(takeUntilDestroyed(this.destroyRef))
				.subscribe({
					next: (blob: Blob): void => {

						const file = new Blob([blob], { type: 'application/pdf' });
						const fileURL = URL.createObjectURL(file);
						window.open(fileURL, '_boleto', 'width=1000, height=800');
						this.isSubmittedDownload = false;
						this.blockedUi = false;
					}, error: (err) => {

						this.isSubmittedDownload = false;
						this.blockedUi = false;

						if (err.status === 404) {
							this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Boleto não encontrado.' });
						} else {
							this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Não foi possível fazer o download do boleto.' });
						}
					}
				});

		}, 1000);

	}

	copyBarcodeToClipboard() {
		navigator.clipboard.writeText(this.barcode)
			.then(_e => {
				this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: "Código de barras copiado para a área de transferência." });
			}).catch(_e => {
				this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Não foi possível copiar o código de barras.' });
			});
	}

	setDateBoleto(date: Date) {
		this.salesDate = new Date(date);
		const today = new Date();
		const diferenca = ((today.getDate() - (this.salesDate.getDate() + 1) * 1))
		this.maxDatePermitted.setDate((this.salesDate.getDate() + 15) * 1);
		this.minDatePermitted.setDate((this.salesDate.getDate() + 2 + diferenca) * 1);
	}

	buttonComeBack() {
		this.paymentMethodService.setPaymentContractSummaryShort(this.paymentContractSummaryShort);
		this.router.navigate(['payment-signature'], { queryParams: { uuid: this.uuid } });
	}

	filterInput(event: Event) {

		const input = event.target as HTMLInputElement;
		const inputValue = input.value;
		const lettersOnly = inputValue.replace(/[^a-zA-Z\s]/g, '');

		input.value = lettersOnly;

	}

}